import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { CONTENT_WIDTH } from './Banner7.const'
import useStyles from './Banner7.styled'

export const useBanner7 = props => {
	const { metaData } = props

	const classes = useStyles(props)

	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })
	const { handleFocus: handleAdditionalButtonClick } = useFieldFocus({ metaData: metaData.additionalButtonAction })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleAdditionalTextClick } = useFieldFocus({ metaData: metaData.additionalText })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.backgroundImage })
	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	return [
		{
			classes,
			withBgImage: !!metaData.backgroundImage?.image,
			backgroundImage: metaData.backgroundImage,
			contentWidth: CONTENT_WIDTH[metaData.contentWidth?.metaValue],
			textShadow: metaData.textShadow?.toNumber(),

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,
		},
		{
			handleImageClick,

			handleTextClick,
			handleTextChange,

			handleButtonClick,

			handleAdditionalTextClick,
			handleAdditionalButtonClick,
		},
	]
}
